import React from 'react';
import { Modal } from 'antd';
import styled from '@emotion/styled';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { TitleModal } from '../../molecules/modal/TitleModal';
import { appStyles } from '../../../styles';
import { CARTNER_CONVOS } from '../../../constants/define/translation';
import { FormConvos } from './forms/FormConvos';
import { QuestionType } from '../../../types/cartnerConvos';

interface FormCartnerConvosModalModalProps {
  isOpenModal: boolean;
  onClose: () => void;
  record?: QuestionType;
  onRefresh: () => void;
  setDataRecord: Function;
}

export const FormCartnerConvosModal = (props: FormCartnerConvosModalModalProps) => {
  const { isOpenModal, onClose, record, onRefresh, setDataRecord } = props;
  const { t } = useTranslation(CARTNER_CONVOS);
  return (
    <StyledModal
      title={<TitleModal title={record ? t('form.updateConvos') : t('form.createConvos')} />}
      centered
      visible={isOpenModal}
      width={1050}
      footer={null}
      onCancel={() => {
        onClose();
        setDataRecord(null);
      }}
      maskClosable={false}
      closeIcon={<CloseCircleOutlined />}
      forceRender
    >
      <FormConvos setDataRecord={setDataRecord} onCloseModal={onClose} onRefresh={onRefresh} record={record} />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  & > .ant-modal-content {
    ${appStyles.commonModalContentStyle}
  }

  .site-card-wrapper {
    ${appStyles.background.modalBgGray}
    & .card-item {
      text-align: center;
      padding: 1rem;
    }
  }

  & h4.ant-typography {
    ${appStyles.color.black}
  }

  .ant-modal-header {
    padding-left: 0;
  }

  .card-item .ant-image {
    cursor: pointer;
  }

  & .card-up-to-date {
    & .ant-image {
      padding: 0px;
      margin-left: 12px;
      & img {
        width: 92%;
        padding: 5px 0 0px 0;
      }
    }
  }
`;
